import Vue from "vue";
import VueRouter from "vue-router";
import Home from "../views/Home.vue";
import News from "../views/News.vue";
import About from "../views/About.vue";
import AboutUs from "../views/AboutUs.vue";
import FoundingStory from "../views/FoundingStory.vue";
import EducationalConcept from "../views/EducationalConcept.vue";
import AboutTeachers from "../views/AboutTeachers.vue";
import IntroduceTeachers from "../views/IntroduceTeachers.vue";
import AboutDirectSchool from "../views/AboutDirectSchool.vue";
import NantunSchool from "../views/NantunSchool.vue";
import West1School from "../views/West1School.vue";
import West2School from "../views/West2School.vue";
import XitunSchool from "../views/XitunSchool.vue";
import AboutJoinedSchool from "../views/AboutJoinedSchool.vue";
import CoursePlanning from "../views/CoursePlanning.vue";
import CoursePlanningElementarySchool from "../views/CoursePlanningElementarySchool.vue";
import CoursePlanningJuniorHighSchool from "../views/CoursePlanningJuniorHighSchool.vue";
import CoursePlanningHighSchool from "../views/CoursePlanningHighSchool.vue";
import ElementarySchoolMathCourse from "../views/ElementarySchoolMathCourse.vue";
import ElementarySchoolChineseCourse from "../views/ElementarySchoolChineseCourse.vue";
import ElementarySchoolNaturalCourse from "../views/ElementarySchoolNaturalCourse.vue";
import ElementarySchoolSocietyCourse from "../views/ElementarySchoolSocietyCourse.vue";
import ElementarySchoolEnglishCourse from "../views/ElementarySchoolEnglishCourse.vue";
import JuniorHighSchoolMathCourse from "../views/JuniorHighSchoolMathCourse.vue";
import JuniorHighSchoolNaturalCourse from "../views/JuniorHighSchoolNaturalCourse.vue";
import JuniorHighSchoolChineseCourse from "../views/JuniorHighSchoolChineseCourse.vue";
import JuniorHighSchoolEnglishCourse from "../views/JuniorHighSchoolEnglishCourse.vue";
import JuniorHighSchoolSocietyCourse from "../views/JuniorHighSchoolSocietyCourse.vue";
import CourseSchedule from "../views/CourseSchedule.vue";
import Rank from "../views/Rank.vue";
// import Schedule from "../views/Schedule.vue";
// import ElementarySchoolSchedule from "../views/ElementarySchoolSchedule.vue";
// import JuniorHighSchoolSchedule from "../views/JuniorHighSchoolSchedule.vue";
import JoinUs from "../views/JoinUs.vue";

//Management
import Manage from "../views/management/Manage.vue";
import Login from "../views/management/Login.vue";
import BannerManager from "../views/management/BannerManager.vue";
import NewsManager from "../views/management/NewsManager.vue";
import RankManager from "../views/management/RankManager.vue";
import TeacherManager from "../views/management/TeacherManager.vue";
import CourseScheduleManager from "../views/management/CourseScheduleManager.vue";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "home",
    component: Home
  },
  {
    path: "privacy-policy",
    name: "PrivacyPolicy",
    component: () => import("../views/PrivacyPolicy.vue")
  },
  {
    path: "/news/:id",
    name: "news",
    component: News
  },
  {
    path: "/about",
    name: "about",
    component: About,
    redirect: { name: "founding-story" },
    children: [
      {
        path: "us",
        name: "about-us",
        component: AboutUs,
        redirect: { name: "founding-story" },
        children: [
          {
            path: "founding-story",
            name: "founding-story",
            component: FoundingStory
          },
          {
            path: "educational-concept",
            name: "educational-concept",
            component: EducationalConcept
          }
        ]
      },
      {
        path: "teachers",
        name: "about-teachers",
        component: AboutTeachers,
        redirect: "/about/teachers/elementary-school",
        children: [
          {
            path: ":school_level/:subject?",
            name: "introduce-teachers",
            component: IntroduceTeachers
          }
        ]
      },
      {
        path: "direct-schools",
        name: "about-direct-schools",
        component: AboutDirectSchool,
        redirect: { name: "about-nantun" },
        children: [
          {
            path: "nantun",
            name: "about-nantun",
            component: NantunSchool
          },
          {
            path: "west-1",
            name: "about-west-1",
            component: West1School
          },
          {
            path: "west-2",
            name: "about-west-2",
            component: West2School
          },
          {
            path: "xitun",
            name: "about-xitun",
            component: XitunSchool
          }
        ]
      },
      {
        path: "joined-school",
        name: "about-joined-school",
        component: AboutJoinedSchool
      }
    ]
  },
  {
    path: "/course-planning",
    name: "course-planning",
    component: CoursePlanning,
    redirect: { name: "elementary-school-course-plan" },
    children: [
      {
        path: "elementary-school",
        name: "elementary-school-course-plan",
        component: CoursePlanningElementarySchool,
        redirect: { name: "elementary-school-math-course" },
        children: [
          {
            path: "math",
            name: "elementary-school-math-course",
            component: ElementarySchoolMathCourse
          },
          {
            path: "chinese",
            name: "elementary-school-chinese-course",
            component: ElementarySchoolChineseCourse
          },
          {
            path: "natural",
            name: "elementary-school-natural-course",
            component: ElementarySchoolNaturalCourse
          },
          {
            path: "english",
            name: "elementary-school-natural-english",
            component: ElementarySchoolEnglishCourse
          },
          {
            path: "society",
            name: "elementary-school-society-course",
            component: ElementarySchoolSocietyCourse
          }
        ]
      },
      {
        path: "junior-high-school",
        name: "junior-high-school-course-plan",
        component: CoursePlanningJuniorHighSchool,
        redirect: { name: "junior-high-school-math-course" },
        children: [
          {
            path: "math",
            name: "junior-high-school-math-course",
            component: JuniorHighSchoolMathCourse
          },
          {
            path: "natural",
            name: "junior-high-natural-course",
            component: JuniorHighSchoolNaturalCourse
          },
          {
            path: "chinese",
            name: "junior-high-school-chinese-course",
            component: JuniorHighSchoolChineseCourse
          },
          {
            path: "english",
            name: "junior-high-school-english-course",
            component: JuniorHighSchoolEnglishCourse
          },
          {
            path: "society",
            name: "junior-high-school-society-course",
            component: JuniorHighSchoolSocietyCourse
          }
        ]
      },
      {
        path: "high-school",
        name: "high-school-course-plan",
        component: CoursePlanningHighSchool
      }
    ]
  },
  {
    path: "/course-schedule",
    name: "course-schedule",
    component: CourseSchedule,
    redirect: "/course-schedule/elementary-school",
    children: [
      {
        path: ":school_level/:location?",
        name: "school-course-schedule",
        component: CourseSchedule
      }
    ]
  },
  {
    path: "/rank",
    name: "rank",
    component: Rank,
    redirect: "/rank/examination"
  },
  {
    path: "/rank/:type",
    name: "rank-type",
    component: Rank
  },
  // {
  //   path: "/schedule",
  //   name: "schedule",
  //   component: Schedule,
  //   redirect: { name: "elementary-school-schedule" },
  //   children: [
  //     {
  //       path: "elementary-school",
  //       name: "elementary-school-schedule",
  //       component: ElementarySchoolSchedule
  //     },
  //     {
  //       path: "junior-high-school",
  //       name: "junior-high-school-schedule",
  //       component: JuniorHighSchoolSchedule
  //     }
  //   ]
  // },
  {
    path: "/join-us",
    name: "join-us",
    component: JoinUs
  },
  {
    path: "/login",
    name: "login",
    component: Login
  },
  {
    path: "/management",
    name: "management",
    component: Manage,
    redirect: { name: "banner-manager" },
    children: [
      {
        path: "banner-manager",
        name: "banner-manager",
        component: BannerManager
      },
      {
        path: "news-manager",
        name: "news-manager",
        component: NewsManager
      },
      {
        path: "rank-manager",
        name: "rank-manager",
        component: RankManager
      },
      {
        path: "teacher-manager",
        name: "teacher-manager",
        component: TeacherManager
      },
      {
        path: "course-schedule-manager",
        name: "course-schedule-manager",
        component: CourseScheduleManager
      }
    ]
  },
  {
    path: "*",
    redirect: { name: "home" }
  }
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes
});
router.beforeEach((to, from, next) => {
  const token = localStorage.getItem("token");
  if (to.name != "login" && to.path.startsWith("/management") && !token) {
    next({ name: "login" });
  } else {
    next();
  }
});

export default router;
